var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',_vm._b({attrs:{"persistent":"","content-class":"modal-dialog__waiting"}},'v-dialog',_vm.$attrs,false),[_c('v-card',{staticClass:"modal-waiting"},[_c('div',{staticClass:"d-inline-flex connection-animate",domProps:{"innerHTML":_vm._s(require('!html-loader!@/assets/icons/connection.svg'))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }